import { useQuery } from '@tanstack/react-query'

import axios from '../../function/axiosInstance'
import { USER_SERVICE_BASE_URL } from '../config'
import extract from '../../function/extract'

const fetchSubscription = async (
  companyId: string
): Promise<{
  status: 'error' | 'ok'
  data: null | { data: Response; status: 'success' }
  error: string | undefined
}> => {
  try {
    const response = await axios.get(
      `${USER_SERVICE_BASE_URL}/companies/${companyId}/capabilities`
    )
    return extract.data(response)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message
    }
  }
}

export const useSubscriptionDetails = (companyId: string) => {
  return useQuery({
    queryKey: ['subscriptionDetails', companyId],
    queryFn: async () => {
      const { data }: any = await fetchSubscription(companyId)
      return data
    }
  })
}
